import { Component } from '@angular/core';

@Component({
  selector: 'p365-rep-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Performa365ExamsReportingClient';
}
